import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import './Dashboard.scss';
import SiderMenu from '../../components/sider/SiderMenu';
import useAuthStore from '../../stores/auth.store';
import AppHeader from '../../components/header/AppHeader';
import { Content } from 'antd/es/layout/layout';

const DashboardPage = () => {
  const username = useAuthStore((state) => state.getUsername());

  return (
    <Layout className="DashboardPage">
      <AppHeader userName={username} />

      <Layout>
        <SiderMenu />
        <Layout>
          <Content>
            <Outlet />
          </Content>
          {/*<Footer className="DashboardPage__footer">
            <img src={'/assets/images/ader.png'} alt="ADER" />
            <div className="DashboardPage__footer__right">
              <img src={'/assets/images/next_generation_eu.png'} alt="Next Generation EU" />
              <img src={'/assets/images/plan_transformacion.png'} alt="Plan Transformación" />
            </div>
          </Footer>*/}
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DashboardPage;
